export const SupportTicketMap = {
    CREATE_TICKET_START: "CREATE_TICKET_START",
    CREATE_TICKET_ERROR: "CREATE_TICKET_ERROR",
    CREATE_TICKET_SUCCESS: "CREATE_TICKET_SUCCESS",

    GET_ALL_USER_TICKETS_START: 'GET_ALL_USER_TICKETS_START',
    GET_ALL_USER_TICKETS_SUCCESS: 'GET_ALL_USER_TICKETS_SUCCESS',
    GET_ALL_USER_TICKETS_ERROR: 'GET_ALL_USER_TICKETS_ERROR',

    GET_TICKET_DETAILS_START: 'GET_TICKET_DETAILS_START',
    GET_TICKET_DETAILS_SUCCESS: 'GET_TICKET_DETAILS_SUCCESS',
    GET_TICKET_DETAILS_ERROR: 'GET_TICKET_DETAILS_ERROR',

    TOGGLE_TICKET_DETAILS_MODAL: 'TOGGLE_TICKET_DETAILS_MODAL',

    ADD_TICKET_COMMENT_START: 'ADD_TICKET_COMMENT_START',
    ADD_TICKET_COMMENT_SUCCESS: 'ADD_TICKET_COMMENT_SUCCESS',
    ADD_TICKET_COMMENT_ERROR: 'ADD_TICKET_COMMENT_ERROR',

    SET_TICKET_BATCH_NUMBER: 'SET_TICKET_BATCH_NUMBER', 
}

export const SupportTicketAction = {
    createTicketStart: () => ({type: SupportTicketMap.CREATE_TICKET_START}),
    createTicketSuccess: (data) => ({type: SupportTicketMap.CREATE_TICKET_SUCCESS, payload: data}),
    createTicketError: () => ({type: SupportTicketMap.CREATE_TICKET_ERROR}),

    getAllUserTicketsStart: () => ({type: SupportTicketMap.GET_ALL_USER_TICKETS_START}),
    getAllUserTicketsSuccess: (data) => ({type: SupportTicketMap.GET_ALL_USER_TICKETS_SUCCESS, payload: data}),
    getAllUserTicketsError: () => ({type: SupportTicketMap.GET_ALL_USER_TICKETS_ERROR}),

    getTicketDetailsStart: () => ({type: SupportTicketMap.GET_TICKET_DETAILS_START}),
    getTicketDetailsSuccess: (data) => ({type: SupportTicketMap.GET_TICKET_DETAILS_SUCCESS, payload: data}),
    getTicketDetailsError: () => ({type: SupportTicketMap.GET_TICKET_DETAILS_ERROR}),

    toggleTicketDetailModal: (data) => ({type: SupportTicketMap.TOGGLE_TICKET_DETAILS_MODAL, payload: data}),

    addTicketCommentStart: () => ({type: SupportTicketMap.ADD_TICKET_COMMENT_START}),
    addTicketCommentSuccess: (data) => ({type: SupportTicketMap.ADD_TICKET_COMMENT_SUCCESS, payload: data}),
    addTicketCommentError: () => ({type: SupportTicketMap.ADD_TICKET_COMMENT_ERROR}),

    setTicketBatchNumber: (data) => ({type: SupportTicketMap.SET_TICKET_BATCH_NUMBER, payload: data}),
}
